import { render, staticRenderFns } from "./informationAddress.vue?vue&type=template&id=08b88f3d&"
import script from "./informationAddress.vue?vue&type=script&lang=js&"
export * from "./informationAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports